<template>
  <v-container fluid>
    <v-card class="specific">
      <v-card-title class="headerCardIndigo white--text">
        <v-layout row>
          <v-flex md9>
            <v-icon dark>mdi-contacts</v-icon>&nbsp;&nbsp;
            <span style="margin-left: 5px">{{ $t('user.coordonne') }}</span>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-container fluid>
        <v-form md12 ref="form">
          <v-layout row wrap>
            <v-flex md6 xs12>
              <v-text-field
                v-model="form.email"
                :readonly="readonly"
                :label="$t('user.details.mail')"
                :rules="[obligatoireRule(), serveurRule('form.email')]"
              />
            </v-flex>
            <v-flex md6 xs12>
              <v-text-field
                v-model="form.portable"
                :readonly="readonly"
                :label="$t('user.details.portable')"
                :rules="[obligatoireRule(), serveurRule('form.portable')]"
              />
            </v-flex>
          </v-layout>
        </v-form>
        <v-layout row>
          <v-flex v-if="readonly" xl2 md4 xs12>
            <v-btn color="success" block small @click="readonly = !readonly">
              <v-icon left> mdi-pencil </v-icon>
              {{ $t('button.edition') }}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions v-if="!readonly">
        <v-layout row justify-center>
          <v-flex md2 mr-2>
            <v-btn mr-5 small block color="success" @click="save()">{{
              $t('button.save')
            }}</v-btn>
          </v-flex>
          <v-flex md2>
            <v-btn small outlined block @click="cancel" color="red">{{
              $t('button.cancel')
            }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>

    <v-card class="specific" style="margin-top: 10px">
      <v-card-title class="headerCardIndigo white--text">
        <v-icon dark>mdi-contacts</v-icon>&nbsp;&nbsp;
        <span style="margin-left: 5px">{{ $t('user.securite') }}</span>
      </v-card-title>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xl2 md4 xs12>
            <v-btn
              color="success"
              block
              small
              v-on:click="dialogPassword = true"
            >
              <v-icon left> mdi-form-textbox-password </v-icon>
              {{ $t('password.changeButton') }}</v-btn
            >
          </v-flex>
          <v-flex xl2 md4 xs12>
            <v-btn
              color="success"
              block
              small
              v-on:click="dialogQuestionSecrete = true"
            >
              <v-icon left> help_outline </v-icon>
              {{ $t('question.changeButton') }}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-dialog v-model="this.dialogQuestionSecrete" persistent max-width="50%">
      <v-form ref="questionForm">
        <v-card>
          <v-card-title class="info white--text">
            {{ $t('question.titleChangeDialog') }}
          </v-card-title>

          <v-card-text class="body-1">
            <br />
            <v-select
              v-model="question.id"
              :items="this.enum.questions"
              :item-text="$t('question.label')"
              item-value="id"
              :label="$t('question.changeDialog.label')"
              dense
              hide-details="auto"
              filled
            >
            </v-select>

            <br />
            <v-text-field
              v-model="question.response"
              filled
              dense
              :label="$t('question.changeDialog.response')"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="changeQuestion">
              {{ $t('button.save') }}
            </v-btn>
            <v-btn text @click="cancelQuestion">
              {{ $t('button.cancel') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="this.dialogPassword" persistent max-width="50%">
      <v-form ref="passwordForm">
        <v-card>
          <v-card-title class="info white--text">
            {{ $t('password.changeButton') }}
          </v-card-title>

          <v-card-text class="body-1">
            <br />
            <v-text-field
              v-model="ancienMotDePasse"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              filled
              dense
              :rules="[obligatoireRule(), serveurRule('AncienMotDePasse')]"
              :type="show1 ? 'text' : 'password'"
              :label="$t('password.changeDialog.oldPassword')"
              @click:append="show1 = !show1"
            />
            <passwordForm
              ref="passwordFormComponent"
              @emitPassword="emitPassword"
              @emitConfirmation="emitConfirmation"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="changePassword">
              {{ $t('button.save') }}
            </v-btn>
            <v-btn text @click="cancelPassword">
              {{ $t('button.cancel') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- Début Dialog Portable incorrect -->
    <v-dialog v-model="dialogPortable" width="500px">
      <v-card>
        <v-toolbar card dark color="orange">
          <v-toolbar-title> {{ $t('participant.attention') }} </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-alert :value="true" color="info" icon="info">
            {{ $t('participant.alertContact') }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="dialogPortable = false"> OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin Dialog avertissement-->
    <v-dialog v-model="disconnectDialog" width="500px" persistent>
      <v-card>
        <v-card-title flat dark color="orange">
          <v-toolbar-title> {{ $t('participant.attention') }} </v-toolbar-title>
        </v-card-title>
        <v-card-text>
          <v-alert :value="true" color="info" icon="info">
            {{ $t('participant.alertDeconnexion') }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="disconnect"> OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import DateFormatter from '@/plugins/mixins/DateFormatter'
import ErrorServeur from '@/plugins/mixins/ErrorServeur'
import ValidationRules from '@/plugins/mixins/ValidationRules'
import PasswordForm from '@/view/Forgot/PasswordForm'
import Api from '@/utils/api'
import { validationMixin } from 'vuelidate'
import toasted from '@/utils/toasted'

export default {
  components: {
    passwordForm: PasswordForm,
  },
  mixins: [DateFormatter, ErrorServeur, ValidationRules, validationMixin],
  data() {
    return {
      isCorrect: false,
      enum: {
        questions: [],
      },
      dialogQuestionSecrete: false,
      dialogPassword: false,
      validate: false,
      show1: false,
      messageGestionnaire: '',
      readonly: true,
      question: {
        id: null,
        response: null,
      },
      ancienMotDePasse: null,
      newPassword: null,
      confirmNewPassword: null,
      form: {
        id: null,
        username: null,
        nom: null,
        prenom: null,
        email: null,
        portable: null,
        password: null,
        role: {},
        etablissement: null,
        entrepriseInsee: null,
        participant: null,
        typeuser: {},
        actif: null,
        dateCreation: null,
        dateModification: null,
        dateConnexion: null,
        heureConnexion: null,
      },
      dialogPortable: false,
      initial: {
        id: null,
        username: null,
        nom: null,
        prenom: null,
        email: null,
        portable: null,
        password: null,
        role: {},
        etablissement: null,
        entrepriseInsee: null,
        participant: null,
        typeuser: {},
        actif: null,
        dateCreation: null,
        dateModification: null,
        dateConnexion: null,
        heureConnexion: null,
      },
      disconnectDialog: false,
    }
  },
  created() {},
  mounted() {},
  computed: {
    roleCorrespondant() {
      return this.$auth.hasRole('ROLE_CORRESPONDANT')
    },
  },
  watch: {},
  beforeMount() {
    new Api('user')
      .get()
      .then((response) => {
        this.initForm(response.body)
        new Api('listeQuestion')
          .get()
          .then((response1) => {
            this.enum.questions = response1.body
          })
          .catch(() => {
            // TODO gestion du cas d'erreur not found
          })
      })
      .catch(() => {
        // TODO gestion du cas d'erreur not found
      })
  },
  methods: {
    emitPassword(value) {
      this.newPassword = value
    },

    emitConfirmation(value) {
      this.confirmNewPassword = value
    },

    initForm(loaded) {
      this.form = loaded
      Object.assign(this.initial, loaded)
    },

    getForms() {
      //access aux formulaire à créer
      if (this.dialogPassword) {
        return [this.$refs.passwordForm]
      }
      if (this.dialogQuestionSecrete) {
        return [this.$refs.questionForm]
      }
      if (!this.dialogQuestionSecrete && !this.dialogPassword) {
        return [this.$refs.form]
      }
    },

    verifIfPortableCorrect(phoneNumber) {
      return this.$api('user/verifIfPortableCorrecte/' + phoneNumber)
        .get()
        .then((response) => {
          return response.body
        })
        .catch((message) => {
          if (message.error == 'access_denied') {
            toasted.error('auth.accessDenied')
          } else {
            toasted.error(
              'Une erreur technique a eu lieu pendant la vérification si le numéro de téléphone portable du participant est correct',
            )
          }
        })
    },

    save(checkPortable = true) {
      // verifier si le numéro de téléphone portable est correct
      if (checkPortable == true) {
        if (this.form.portable != null) {
          this.verifIfPortableCorrect(this.form.portable).then(
            (portableCorrecte) => {
              if (portableCorrecte == false) {
                this.dialogPortable = true
              } else {
                this.doUpdate()
              }
            },
          )
        }
      }
    },
    doUpdate() {
      const ok = this.__validerForm()
      if (ok) {
        this.$api('user')
          .post(this.form)
          .then(
            (response) => {
              this.initForm(response.body)
              this.readonly = !this.readonly
              this.__reset()
              this.disconnectDialog = true
            },
            (response) => {
              this.errorsHandler(response)
            },
          )
          .catch(() => {})
      }
    },
    cancel() {
      Object.assign(this.form, this.initial)
      this.readonly = true
      this.__reset()
    },
    changeQuestion() {
      this.$api('user/question')
        .post(this.question)
        .then(
          () => {
            this.cancelQuestion()
          },
          () => {
            // toasted.error('form.error');
          },
        )
    },
    cancelQuestion() {
      this.dialogQuestionSecrete = false
      this.question.id = null
      this.question.response = null
    },
    cancelPassword() {
      this.dialogPassword = false
      this.ancienMotDePasse = null
      this.newPassword = null
      this.confirmNewPassword = null
      this.$refs.passwordFormComponent.resetForm()
    },

    __validerForm() {
      this.resetErreur()
      try {
        const ok = this.$refs.form.validate()
        return ok
      } catch (e) {
        return false
      }
    },

    __validerPassword() {
      this.resetErreur()
      try {
        const ok = this.$refs.passwordForm.validate()
        return ok
      } catch (e) {
        return false
      }
    },

    __validerQuestion() {
      this.resetErreur()
      try {
        const ok = this.$refs.questionForm.validate()
        return ok
      } catch (e) {
        return false
      }
    },

    changePassword() {
      //lance la validation
      const ok = this.__validerPassword()
      if (ok) {
        this.$api('/changePassword', '/oauth')
          .post({
            ancienMotDePasse: this.ancienMotDePasse,
            motDePasse: this.newPassword,
          })
          .then(() => {
            this.cancelPassword()
            toasted.info(this.$t('password.confirmationChange'))
          })
          .catch((errors) => {
            this.errorsHandler(errors)
          })
      }
    },
    disconnect() {
      this.disconnectDialog = false
      this.$auth.logout()
    },
  },

  validations: {},
}
</script>
